<template>
  <offer-section class="offer-specificities-section">
    <template #title>
      <offer-section-title :title="$tc('app.labels.specificities.title', 2) | capitalize">
        <ui-ctk-icon
          name="hatch"
          class="tw-text-blue-500 tw-text-3xl"
        />
      </offer-section-title>
    </template>

    <div class="offer-specificities-section__items tw-flex tw-flex-wrap tw-mb-6">
      <!-- Vehicle types -->
      <offer-group-item
        :title="$tc('app.labels.vehicle_detail.title', 2) | capitalize"
        v-if="offer.vehicle_types.length"
        data-test="vehicle-types"
        class="tw-pr-4 tw-border-r tw-border-gray-300 dark:tw-border-gray-700"
      >
        <span
          v-for="(vehicle, index) in offer.vehicle_types"
          :key="'vehicle-' + index"
        >
          {{ vehicle.label | capitalize }}<span v-if="index < offer.vehicle_types.length - 1">,&nbsp;</span>
        </span>
      </offer-group-item>

      <!-- Equipments -->
      <offer-group-item
        :title="$tc('app.labels.equipment.title', 2) | capitalize"
        v-if="offer.equipments && offer.equipments.length"
        data-test="equipments"
        class="tw-pl-4"
      >
        <span
          v-for="(equipment, index) in offer.equipments"
          :key="'equipment-' + index"
        >
          {{ equipment.label | capitalize }}<span v-if="index < offer.equipments.length - 1">,&nbsp;</span>
        </span>
      </offer-group-item>
    </div>
  </offer-section>
</template>

<script>
  import { defineComponent } from '@vue/composition-api'

  import OfferSection from '@/views/Carriers/Offers/components/OfferDetail/components/OfferSection/index.vue'
  import OfferSectionTitle from '@/views/Carriers/Offers/components/OfferDetail/components/OfferSection/OfferSectionTitle/index.vue'
  import OfferGroupItem from '@/views/Carriers/Offers/components/OfferDetail/components/OfferGroupItem/index.vue'
  import OfferSpecificityGroup from '@/views/Carriers/Offers/components/OfferDetail/components/OfferSpecificityGroup/index.vue'
  import OfferSpecificityItem from '@/views/Carriers/Offers/components/OfferDetail/components/OfferSpecificityGroup/_subs/OfferSpecificityItem/index.vue'

  /**
   * @module component - OfferVehicleSection
   */
  export default defineComponent({
    name: 'OfferVehiclesSection',
    components: {
      OfferSection,
      OfferSectionTitle,
      OfferGroupItem,
      OfferSpecificityGroup,
      OfferSpecificityItem
    },
    props: {
      offer: {
        type: Object,
        required: true
      }
    }
  })
</script>

<style lang="scss" scoped>.offer-specificities-section {
  position: relative;
}
.offer-specificities-section__items {
  margin: -1rem;
}
.offer-specificities-section__items .offer-group-item {
  margin-bottom: 0.5rem;
  position: relative;
  margin: 1rem;
  flex: 1 0 calc(45% - 2rem);
}
@media (min-width: 770px) {
  .offer-specificities-section__items .offer-group-item {
    flex: 1 0 calc(18% - 1rem);
  }
  .offer-specificities-section__items .offer-group-item:not(:last-child) {
    position: relative;
  }
  .offer-specificities-section__items .offer-group-item:not(:last-child)::after {
    --tw-border-opacity: 1;
    border-color: rgba(214, 214, 218, var(--tw-border-opacity));
    border-style: solid;
    border-top-width: 1px;
    border-left-width: 1px;
    border-bottom-width: 1px;
    border-right-width: 0px;
    height: 100%;
    position: absolute;
    content: '';
    width: 1px;
    right: -1rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}</style>
